import React from 'react';

/**
 * RoomCardSkeleton — app-like loading placeholder for mobile room cards.
 * Spinner ki jagah skeleton (animate-pulse) — native app jaisa feel + perceived speed.
 */
const RoomCardSkeleton = ({ count = 3 }) => {
  return (
    <div className="space-y-4" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden mb-4">
          {/* Image — match real card height (h-48) to avoid layout shift on load */}
          <div className="w-full h-48 bg-gray-200 animate-pulse" />
          <div className="p-4">
            {/* Title */}
            <div className="h-4 w-2/3 bg-gray-200 rounded animate-pulse mb-3" />
            {/* Meta row */}
            <div className="flex gap-3 mb-4">
              <div className="h-3 w-16 bg-gray-200 rounded animate-pulse" />
              <div className="h-3 w-16 bg-gray-200 rounded animate-pulse" />
              <div className="h-3 w-12 bg-gray-200 rounded animate-pulse" />
            </div>
            {/* Rate row */}
            <div className="flex items-center justify-between pt-3 border-t border-gray-100">
              <div className="space-y-2">
                <div className="h-3 w-24 bg-gray-200 rounded animate-pulse" />
                <div className="h-5 w-20 bg-gray-200 rounded animate-pulse" />
              </div>
              <div className="h-9 w-24 bg-gray-200 rounded-lg animate-pulse" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RoomCardSkeleton;
